import './App.css';
import { Route, Routes, Navigate } from 'react-router-dom';
import ProtectedRoute from './protectedRoutes/protectedRoutes'
import Login from './components/login';
import Dashboard from './components/Dashboard/dashboard';
import ReservationList from './components/Reservation/reservationList';
import Menu from './components/Menu/menu';
import Caisse from './components/Cassie/cassie';
import ReservationDetails from './components/Reservation/reservationDetails';
import Profile from './components/profile';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path='/login' element={<Login />} />
      <Route path='/profile' element={<Profile />} />
      <Route path='/unauthorized' />

      <Route path='/dashboard' element={
        <ProtectedRoute roles={['admin']}>
          <Dashboard />
        </ProtectedRoute>
      }></Route>

      <Route path='/reservations' element={
        <ProtectedRoute roles={['admin']}>
          <ReservationList />
        </ProtectedRoute>
      }></Route>

      <Route path='/reservations/:id' element={
        <ProtectedRoute roles={['admin']}>
          <ReservationDetails />
        </ProtectedRoute>
      }></Route>

      <Route path='/caisse/*' element={
        <ProtectedRoute roles={['admin', 'user']}>
          <Caisse />
        </ProtectedRoute>
      }></Route>

      <Route path='/menu/*' element={
        <ProtectedRoute roles={['admin']}>
          <Menu />
        </ProtectedRoute>
      }></Route>

    </Routes>
  );
}

export default App;
